import { render, staticRenderFns } from "./15.vue?vue&type=template&id=237284c0&scoped=true&"
import script from "./15.vue?vue&type=script&lang=js&"
export * from "./15.vue?vue&type=script&lang=js&"
import style0 from "./15.vue?vue&type=style&index=0&id=237284c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237284c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237284c0')) {
      api.createRecord('237284c0', component.options)
    } else {
      api.reload('237284c0', component.options)
    }
    module.hot.accept("./15.vue?vue&type=template&id=237284c0&scoped=true&", function () {
      api.rerender('237284c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/15.vue"
export default component.exports